export default "__VITE_ASSET__BKZUlp$8__"